var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container content clearfix",attrs:{"id":"registerBlock"}},[_c('div',{staticClass:"wrapper clearfix"},[_c('div',{staticStyle:{"padding":"5px"}},[_c('br'),_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t("Thank you for registering for" + this.prov_short, {
              election_name: _vm.election_name,
            }))+".")])]),_c('p',[_vm._v("\n        "+_vm._s(_vm.$t(
            "You have been sent a confirmation email containing all of your registration information. Please review it and inform us of any changes as early as possible."
          ))+"\n      ")]),_c('p',[_vm._v("\n        "+_vm._s(_vm.$t(
            "If the message has not arrived in your mailbox, please check your junk folder or check with our team to make sure that your registration was submitted."
          ))+"\n      ")]),_c('p',{domProps:{"innerHTML":_vm._s(
          _vm.$t(
            'If you need any assistance, please don\'t hesitate to contact us at 1-866-488-8775 or hello@civix.ca'
          )
        )}}),_c('p',[_c('a',{attrs:{"href":_vm.$t('site')}},[_vm._v(_vm._s(_vm.$t("Return to Student Vote")))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }